import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_IDENTITY } from "../../config/config.json";
import { decryptStorage } from 'utils/utils';

const prepareHeaders = (includeAuthorization = true) => (headers) => {
    headers.set('content-type', 'application/json');
    headers.set('accept', '*/*');
    headers.set('Accept-Encoding', 'gzip, deflate, br');
    headers.set('Connection', 'keep-alive');

    if (includeAuthorization) {
        const token = decryptStorage(localStorage.getItem("token")) || decryptStorage(sessionStorage.getItem("tokenTemp"));
        if (token) headers.set('Authorization', `Bearer ${token}`);
    }

    return headers;
};

const baseQuery = fetchBaseQuery({
    baseUrl: API_IDENTITY,
    extraOptions: { timeout: 30000 },
    prepareHeaders: prepareHeaders(true), // Por defecto, se incluye la autorización
});

export const microServiceIdentityAPI = createApi({
    reducerPath: 'microServiceIdentityAPI',
    baseQuery,
    endpoints: () => ({})
});

export const microServiceIdentityAPIWithTokenRevocation = createApi({
    reducerPath: 'microServiceIdentityAPIWithTokenRevocation',
    baseQuery: fetchBaseQuery({
        baseUrl: API_IDENTITY,
        extraOptions: { timeout: 30000 },
        prepareHeaders: (headers) => {
            headers.set('content-type', 'application/json')
            headers.set('access-control-allow-origin', '*')
            headers.set('accept', '*/*')
            const tokenRevocationGSE = decryptStorage(localStorage.getItem("tokenRevocationGSE"))
            if (tokenRevocationGSE) headers.set('Authorization', `Bearer ${tokenRevocationGSE}`)
            return headers
        } 
    }),
    endpoints: () => ({})
});

